var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 19.7501C16.4997 17.8052 15.7271 15.9399 14.3518 14.5646C12.9765 13.1894 11.1113 12.4167 9.16634 12.4167C7.22142 12.4167 5.35616 13.1894 3.98089 14.5646C2.60562 15.9399 1.83301 17.8052 1.83301 19.7501",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 12.4167C11.6976 12.4167 13.7497 10.3646 13.7497 7.83333C13.7497 5.30203 11.6976 3.25 9.16634 3.25C6.63504 3.25 4.58301 5.30203 4.58301 7.83333C4.58301 10.3646 6.63504 12.4167 9.16634 12.4167Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1671 18.8333C20.1671 15.7441 18.3337 12.8749 16.5004 11.4999C17.103 11.0478 17.5849 10.4541 17.9034 9.77135C18.2219 9.0886 18.3672 8.33786 18.3264 7.58559C18.2856 6.83331 18.06 6.10268 17.6696 5.45837C17.2791 4.81406 16.7359 4.27593 16.0879 3.8916",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.e34251dfc6ba53848bbb050a20f274ad.svg";
export { ForwardRef as ReactComponent };